import React from "react";

import { Box, Typography, Paper } from "@mui/material";

import { config, styles } from "../../style";

import ArticleIcon from "@mui/icons-material/Article";

export const ErrorScreen = (props) => {
    return (
        <Paper sx={{ mt: "16px", p: "1rem" }} elevation={1}>
            <Typography sx={{ ...styles.cardHeading, WebkitLineClamp: "0" }}>
                Sorry! We don't have any homes in your area right now, but we are always expanding our inventory, so
                come back soon!
            </Typography>

            <Typography
                sx={{ ...styles.subHeading, mt: "1rem", overflow: "auto", textOverflow: "unset", display: "block" }}>
                Help us expand to where you need us most by filling out this survey to let us know where you'd like us
                to offer homes by clicking on this link and completing this brief questionnaire.
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center" }}>
                <ArticleIcon sx={{ color: "#155B75", mr: "5px", mt: "2px" }}></ArticleIcon>
                <a
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: "#155B75" }}
                    href="https://form.jotform.com/241137055820146">
                    Request New Market
                </a>
            </Box>

            <Typography sx={{ ...styles.subHeading, mt: "1rem" }}>
                Here’s what you can do for results to appear:
            </Typography>
            <ul style={{ marginLeft: "1.5rem", marginTop: ".5rem" }}>
                <li>
                    <Typography sx={{ ...styles.cardHeading, fontSize: config.subHeadingFontSize }}>
                        Zoom out
                    </Typography>
                </li>
                <li>
                    <Typography sx={{ ...styles.cardHeading, fontSize: config.subHeadingFontSize }}>
                        Clear the map boundary
                    </Typography>
                </li>
                <li>
                    <Typography
                        component="span"
                        sx={{ ...styles.cardHeading, fontSize: config.subHeadingFontSize, display: "inline" }}>
                        Reset all filters{" "}
                        <span style={{ ...styles.subHeading, display: "inline", fontWeight: "400" }}>or</span> remove{" "}
                        <span style={{ ...styles.subHeading, display: "inline", fontWeight: "400" }}>
                            one of them below until you see more homes
                        </span>
                    </Typography>
                </li>
            </ul>
        </Paper>
    );
};
